import React, { useEffect } from "react";
import "./Aboutdsamesh.css";
// import ownerimg from "../../assets/about/DASMESHH 1.svg";
import { useLocation } from "react-router-dom";

const aboutimg = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273167/11_ubxmmv.png";
const asec2img = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273211/12_gettct.png";
const g2img = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273183/13_sa4shx.png";
const g1img = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273161/14_ueo2oy.png";
const g22left = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273144/15_n7fa6m.png";
const g22right = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273151/17_jjnscj.png";
const g21right = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742273166/16_nhwmbl.png";
const arrowholding = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742468764/arrowholding_hoigb1.png";
const growth = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742551722/growth_mvj4cw.png";

const Aboutdasmesh = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if targetid is passed in state and scroll to the section with the corresponding id
    if (location.state && location.state.targetid) {
      const sectionId = location.state.targetid;
      const element = document.getElementById(sectionId);
      if (element) {
        // Scroll to the section
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      {/* First Section */}
      <div className="aboutpage">
        <div className="aboutleft">
          {/* Heading */}
          <div className="aboutheading">
            <p>"SEEDS OF EXCELLENCE, HARVESTS OF PRIDE: FARMING WITH TRADITION, INNOVATING FOR TOMORROW."</p>
          </div>

          <div className="aboutpara">
            <div className="apara1">
              <div className="paracontent">
                <p>The unwavering passion and commitment to agriculture, coupled with a sense of responsibility towards fellow farmers, drove Brothers S. Amar Singh, S. Karnail Singh, S. Mohan Singh and S. Harpal Singh to establish DASMESH GROUP MALERKOTLA. In 1982, they ploneered the design and innovation of a revolutionary agricultural machine that could harvest and thresh simultaneously.</p>
              </div>
              <div className="paracontent">
                <p>Thirty-five years later, our farmer-driven organization remains flexible, ägile, and innovative, dedicated to empowering agricultural producers. We take immense pride in our legacy of manufacturing breakthrough agricul-tural products, including:-</p>
              </div>
              <ul className="paraul">
                <li>Advanced Self-Propelled Wheel Type Combine Harvesters</li>
                <li>Self-Propelled Track Combine esters</li>
                <li>Tractor Driven Combine Harvesters</li>
                <li>Straw Reaper</li>
                <li>Rotavator</li>
                <li>Roto Seed Drill</li>
                <li>Laser Levellers</li>
              </ul>
            </div>
            <div className="apara2">
              <div className="paracontent">
                <p>At DASMESH GROUP MALERKOTLA, we e recognize recognize agriculture's ever-changing nature from seasons to weather to market fluctuations. That's why we continuously evolve our farming equipment to meet these challenges.</p>
              </div>
              <div className="paracontent">
                <p>Our devotion to agricultural innovation and confidence in our products' superiority have yielded reliable and exceptional machineries. Our goal is to earn trust. Our expanding market share in India and strong presence in countries like Sri Lanka, Iraq, Bangladesh, Thailand, Nigeria, Kenya African Countries, Gulf, Europe & Asian Countries</p>
              </div>
            </div>
          </div>

          <div className="aboutlast">
            <p>The idea is to "Empowering farmers to bloom with every season".</p>
          </div>
        </div>
        <div className="aboutright">
          <div className="arightimg">
            <h3>ABOUT US</h3>
            <img src={aboutimg} alt="" />
          </div>
        </div>
      </div>

      {/* Second Section */}
      <div className="aboutsection2">
        <div className="asec2heading">
          <h3>LEADING WITH COMMITMENT</h3>
        </div>
        <div className="asec2content">
          <div className="asec2para">
            <div className="as2p1">
              <p>When DASMESH was started in 1982; its only mission was to ease off the toil of farmers and render quality products worthy of winning their trust. 35 years hence; we still stand by that honourable mission. Even as a truly global company, present around the world through its products, research and development inputs, industrial and commercial efforts, and worldwide dealer network; DASMESH has come a long way offering one of the widest, most flexible ranges of agricultural machinery and industrial</p>
            </div>
            <div className="as2p2">
              <p>of success by manufacturing different variants of Self Propelled Combine Harvester Combines and Tractor Driven Harvester since 1982. The company has its plant situated at Malerkotla district Sangrur within the State of Punjab.</p>
              <p>Company's outstanding commitment stems directly from its passionate philosophy focused on agriculture's development. Company's market and</p>
            </div>
          </div>
          <div className="asec2img">
            <img src={asec2img} alt="" />
          </div>
          <div className="asec2para">
            <div className="as2p1">
              <p>equipment. As the leading manufacturer of Combine harvesters in India commanding 35% market share and an ISO 9001:2015 certification TUV Germany; DASMESH GROUP, MALERKOTLA. Continues to scale new zeniths</p>
            </div>
            <div className="as2p2">
              <p>commercial approach begins and ends with the happiness of farmers. And that has been the reason for some big innovations like India,s Maize Combine Harvester first Any product, 2 yearback.</p>
          </div>
          </div>
        </div>

        <div className="asec2mobile">
          <div className="asec2mobileimg">
            <img src={asec2img} alt="" />
          </div>
          <div className="asec2contentmobile">
            <p>When DASMESH was started in 1982; its only mission was to ease off the toil of farmers and render quality products worthy of winning their trust. 35 years hence; we still stand by that honourable mission.</p>
            <p>Even as a truly global company, present around the world through its products, research and development inputs, industrial and commercial efforts, and worldwide dealer network; DASMESH has come a long way offering one of the widest, most flexible ranges of agricultural machinery and industrial equipment.</p>
            <p>As the leading manufacturer of Combine harvesters in India commanding 35% market share and an ISO 9001:2015 certification TUV Germany; DASMESH GROUP, MALERKOTLA. Continues to scale new zeniths of success by manufacturing different variants of Self Propelled Combine Harvester Combines and Tractor Driven Harvester since 1982. The company has its plant situated at Malerkotla district Sangrur within the State of Punjab.</p>
            <p>Company's outstanding commitment stems directly from its passionate philosophy focused on agriculture's development. Company's market and</p>
            <p>commercial approach begins and ends with the happiness of farmers. And that has been the reason for some big innovations like India,s Maize Combine Harvester first Any product, 2 yearback.</p>
          </div>
        </div>
      </div>

      {/* Third Section */}
      <div className="growth">
        <div className="arrowdiv">
          <img src={arrowholding} alt="" />
        </div>
        <div className="growthinside">
          <div className="growth1">
            <div className="g1heading">
              <img src={growth} alt=""/>
            </div>
            <div className="g1img">
              <img src={g1img} alt="" />
            </div>
          </div>
          <div className="growth2">
            <div className="g2img">
              <img src={g2img} alt="" />
            </div>
            <div className="g2content">
              <div className="g21">
                <div className="g21left">
                  <div className="g21text">
                    <p>Since the time DASMESH MECHANICAL WORKS (P) LTD has expanded its business vision to move beyond Combine harvesters to the smaller equipments that will help improve productivity in Indian agriculture; we have appointed a reliable network of authorized dealers to reach to all nooks and corner of India with our quality products and excellent after-sales services.</p>
                  </div>
                  <div className="g21text">
                    <p>The company treats its dealers as channel partners who have joined hands with us to provide a common platform to share knowledge and best practices related to farming and mechanization in India. At present, there are.... Dealers and... marketing partners to reach across all the farmers in India and abroad.</p>
                  </div>
                </div>
                <div className="g21right">
                  <img src={g21right} alt="" />
                </div>
              </div>
              <div className="g22">
                <div className="g22left">
                  <img src={g22left} alt="" />
                </div>
                <div className="g22right">
                  <img src={g22right} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>





      {/* design start */}
      {/* <div className="about-dasmesh-section-1" id="abouttop">
        <h3>ABOUT DASMESH</h3>
        <div className="about-dsmesh-section-2">
          <div className="about-dasmesh-text">
            <p>
              Welcome To DASMESH Group - Malerkotla, Punjab, INDIA. DASMESH Is
              Leader In Harvesting Technology In Agriculture Sector In India
              Since 1970. We Are Into The Manufacturing Of Agricultural
              Products, As Per Latest Trend And Requirement In Market. The
              Company Is Leader In Various Products Like Self Propelled Combine
              Harvesters, Track Type Combine Harvester, Tractor Driven Combine
              Harvester, Super Seeder, Straw Reaper, Rotavator, Roto-seed Drill
              & Primary Tillage Farming Equipment.
            </p>
          </div> */}
          {/* <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="about-dasmesh-img">
                <img src={ownerimg} alt="ownerimg" />
                  <div className="about-dasmesh-owner-name">
                    <h4>S. Amar Singh</h4>
                    <h5>(CMD, DASMESH Group)</h5>
                  </div>
              </div>  
              
            </div>
            <div className="col-lg-8 col-md-6">
              
            </div>
          </div> */}
        {/* </div>
      </div> */}

      {/* <div className="about-dasmesh-section-3">
        <p>
          DASMESH is a family owned company committed to Innovative, Sustainable
          and high-quality Agricultural Products for farmers worldwide. We are
          an ISO 9001:2015 Certified Company and are also registered with
          Registrar Of Companies under Indian Companies Act 1956. DASMESH is a
          leader in agricultural product manufacturing industry with
          next-generation mechanical & technology engineering practices for new
          and retrofit products. We manufacture high-performance products that
          reduce operating costs while providing efficient output quality in
          agriculture industry.
        </p>
        <p>
          DASMESH is best known for its sustainable agricultural products and
          ethical business practices which have garnered recognition and
          numerous awards (including National Award by President of INDIA) for
          leadership and success. Sustainability and Efficient design is in the
          company’s DNA and is core to our employee’s beliefs. It guides our
          business. Our commitment to sustainable agricultural implements and
          good business practices is evident in new standards defined by our
          leadership. These standards include high-performance agricultural
          products that are efficient, environmentally friendly, and efficient
          in terms of fuel, user friendly and easy to operate.
        </p>
        <p>
          We know that successful relationships lead to successful brand.
          DASMESH achieves higher-than-industry-average retention rates for
          customers and employees because we focus on after sales service,
          employee development and recognition, philanthropic and volunteer
          efforts, and sustainable practices.
        </p>
        <p>
          Since its beginnings 43 years ago, the company has grown from a small,
          single-office cum workshop to become a Top 5 agricultural products
          manufacturer and exporters of India. This growth process has brought
          ample change, but the cornerstone commitments have remained the same:
          Integrity, Safety, Quality and Performance. These commitments, along
          with a focus on customers and employees, have allowed DASMESH to
          become the most trusted agricultural company and develop strong
          relationships with our customers.
        </p>
        <p id="group">
          DASMESH has strong dealers network for Sales & Service nationwide.
          Along with Indian market, our products are exported to many countries
          to contribute in Global Agricultural Community with a full range of
          high-quality, cost-effective agricultural products and implements.
        </p>
      </div> */}

      {/* <div className="about-dasmesh-section-4">
        <h3>GROUP OF COMPANIES</h3>
        <p>
          DASMESH is a group of companies that have been set up over a period
          spanning four decades. It is no mean achievement that every DASMESH
          company is either a market leader or ranks among the top three in the
          country in its field of agricultural product manufacturering and
          export. Integrating these multifarious units and operations with a
          diverse work force has made DASMESH the large Agricultural Group that
          it is today.
        </p>
        <p>
          <span>
            <span className="list"></span>DASMESH Mechanical Works Private Limited
          </span>
           is Flagship company of the DASMESH GROUP. The company manufactures
          wide range of Combine Harvesters i.e. Self Propelled Combine
          Harvesters, Tractor Driven Combine Harvesters, Track Combine
          Harvesters etc. DASMESH is Leader in Combine Harvesters market in
          India and has around 35% share in Combine Harvester segment. Our
          combine harvesters are most popular in developing nations and we are
          spanning our global network throughout all 6 continents
        </p> */}
        {/* <p><span><div className="list"></div></span></p> */}
        {/* <p><span><div className="list"></div>.</span></p> */}
        {/* <p id="ourhistory">
          <span>
            <span className="list"></span>DASMESH Agricultural Industries Private
            Limited
          </span>
           we take immense pride in being a leading manufacturer of high-quality
          agriculture implements designed to meet the growing demands of modern
          farming. As the flagship company of the DASMESH GROUP, we have
          established a reputation for producing innovative and reliable
          agriculture implements that enhance productivity and efficiency in
          agriculture.'
        </p>
      </div> */}
    </>
  );
};

export default Aboutdasmesh;
